import React, {Component} from 'react';
import {connect} from 'react-redux';
import Login from '../components/Login';

class HomeContainer extends Component {

    render() {
        return (
            <Login />
        );
    }
}


export default HomeContainer = connect(state => {
    return {
        ETMSUser: state.data.ETMSUser
    }
})(HomeContainer)



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.jsx